<template>
  <v-card
    outlined
    :class="classes['card']"
    :style="styles['card']"
    :max-height="isMobile ? undefined : cardsMaxHeight"
    :max-width="cardsMaxWidth"
    :min-height="cardsMinHeight"
    :min-width="cardsMinWidth"
    :height="isMobile ? undefined : height"
    :width="width"
  >
    <div 
      class="d-none d-sm-flex align-center"
      style="height: 100%; overflow: scroll"
    >
      <v-img
        style="width: 50%; height: 100%"
        :src="imageUrl"
      ></v-img>
      <div 
        style="width: 50%; height: 100%; overflow-y: scroll"
        class="d-flex flex-column"
        :min-height="cardsMinHeight"
        :max-height="isMobile ? undefined : cardsMaxHeight"
      >
        <slot name="title">
          <h3 
            class="ma-3" 
            style="word-break: keep-all; cursor: pointer"
            v-on:click="emit('title-click')"
          >{{title}}</h3>
        </slot>
        <slot name="description">
          <p 
            class="font-weight-light mx-3"
            v-on:click="emit('description-click')"
          >
            {{description}}
          </p>
        </slot>
        <div class="mt-auto d-flex flex-wrap" style="overflow: hidden">
          <v-avatar 
            class="mb-5 ml-5" 
            v-on:click="emit('avatar-click')"
          >
            <v-img
              :src="avatarUrl"
            ></v-img>
          </v-avatar>
          <div class="ml-2" style="font-size: 9pt">
            <div>{{author}}</div>
            <p class="font-weight-light" style="font-size: 9pt">{{publicationDate}}</p>
          </div>
          <slot name="actions">
            <div class="ml-auto d-flex align-top">
              <v-btn
                icon
                class="mr-3"
                v-on:click="emit('action-click')"
              >
                <v-icon>{{actionIcon}}</v-icon>
              </v-btn>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <template>
      <v-img
        :src="imageUrl"
        class="d-flex d-sm-none align-center"
        :height="height"
      ></v-img>
      <v-card-title
        class="d-flex d-sm-none align-center"
      >
        <slot name="title">
          <h3 
            v-on:click="emit('title-click')"
            class="mx-3" 
            style="word-break: keep-all; cursor: pointer"
          >{{title}}</h3>
        </slot>
      </v-card-title>
      <v-card-text>
        <slot name="description">
          <p 
            class="d-flex d-sm-none font-weight-light mx-3"
            v-on:click="emit('description-click')"
          >
            {{description}}
          </p>
        </slot>
        <div class="d-flex d-sm-none mt-auto" style="overflow: hidden">
          <v-avatar 
            class="mb-5 ml-5"
            v-on:click="emit('avatar-click')"
          >
            <v-img
              :src="avatarUrl"
            ></v-img>
          </v-avatar>
          <div class="ml-2" style="font-size: 9pt">
            <div>{{author}}</div>
            <p class="font-weight-light" style="font-size: 9pt">{{publicationDate}}</p>
          </div>
          <slot name="actions">
            <div class="ml-auto d-flex align-top">
              <v-btn
                icon
                class="mr-3"
                v-on:click="emit('action-click')"
              >
                <v-icon>{{actionIcon}}</v-icon>
              </v-btn>
            </div>
          </slot>
        </div>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import emittable from '../../../mixins/emittable'

import {
  VCard,
  VImg,
  VAvatar,
  VBtn,
  VIcon,
  VCardTitle,
  VCardText,
} from 'vuetify/lib'

export default {
  name: "ArticlePreview",
  components: {
    VCard,
    VImg,
    VAvatar,
    VBtn,
    VIcon,
    VCardTitle,
    VCardText
  },
  mixins: [emittable],
  data: function() {
    return {}
  },
  props: {
    cardsMinWidth: {
      type: String,
      default: undefined
    },
    cardsMinHeight: {
      type: String,
      default: undefined
    },
    cardsMaxWidth: {
      type: String,
      default: undefined
    },
    cardsMaxHeight: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: "600px"
    },
    height: {
      type: String,
      default: "300px"
    },
    title: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: undefined
    },
    author: {
      type: String,
      default: undefined
    },
    publicationDate: {
      type: String,
      default: undefined
    },
    actionIcon: {
      type: String,
      default: "mdi-bookmark"
    },
    avatarUrl: {
      type: String,
      default: undefined
    },
    imageUrl: {
      type: String,
      default: undefined
    },
    styles: {
      type: Object,
      default: function () {
        return {
          card: {},
          actions: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          card: {},
          actions: {},
        };
      },
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name == 'xs'
    }
  }
}
</script>

<style>

</style>